module.exports = __webpack_public_path__ + "static/media/SmithAnnounce.4db0b3e3.jpg";